/**
 * 레벨 정책 정본 (활동 점수 기반)
 * - 게시글 +10 / 댓글·답글 +3 / 출석체크 +5 / 공개 매매일지 +7
 */
export const LEVEL_INFO = {
  1:  { label: 'Lv.1',  minScore: 0,     color: '#94a3b8' },
  2:  { label: 'Lv.2',  minScore: 100,   color: '#38bdf8' },
  3:  { label: 'Lv.3',  minScore: 300,   color: '#3b82f6' },
  4:  { label: 'Lv.4',  minScore: 600,   color: '#6366f1' },
  5:  { label: 'Lv.5',  minScore: 1000,  color: '#8b5cf6' },
  6:  { label: 'Lv.6',  minScore: 2000,  color: '#a855f7' },
  7:  { label: 'Lv.7',  minScore: 4000,  color: '#ec4899' },
  8:  { label: 'Lv.8',  minScore: 7000,  color: '#f97316' },
  9:  { label: 'Lv.9',  minScore: 11000, color: '#f59e0b' },
  10: { label: 'Lv.10', minScore: 16000, color: '#ef4444' },
} as const;

export type Level = keyof typeof LEVEL_INFO;
export const MAX_LEVEL: Level = 10;

export const ACTIVITY_SCORE_RULES = [
  { label: '게시글 작성', delta: 10 },
  { label: '댓글/답글 작성', delta: 3 },
  { label: '출석체크', delta: 5 },
  { label: '매매일지 작성 (공개)', delta: 7 },
] as const;

export function getLevelInfo(level: number) {
  const lv = (Math.min(Math.max(1, level), MAX_LEVEL) as Level);
  return { ...LEVEL_INFO[lv], level: lv };
}

export function calcLevel(score: number): Level {
  for (let lv = MAX_LEVEL; lv >= 1; lv--) {
    const info = LEVEL_INFO[lv as Level];
    if (score >= info.minScore) return lv as Level;
  }
  return 1;
}

export function progressToNextLevel(score: number): {
  current: Level;
  next: Level | null;
  percent: number;
  remaining: number;
} {
  const current = calcLevel(score);
  if (current === MAX_LEVEL) return { current, next: null, percent: 100, remaining: 0 };

  const next = (current + 1) as Level;
  const curMin = LEVEL_INFO[current].minScore;
  const nextMin = LEVEL_INFO[next].minScore;
  const span = nextMin - curMin;
  const gained = score - curMin;
  return {
    current,
    next,
    percent: Math.min(100, Math.round((gained / span) * 100)),
    remaining: Math.max(0, nextMin - score),
  };
}
